import React, { useRef } from 'react';
import { Transition } from 'react-transition-group';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { PrimaryButton, NavButtonGroup } from '../components/buttons';
import Header from '../components/Header';
import VideoControls from '../components/VideoControls';
import {
  pageTransitionDurationMs,
  transitionStylesCrossFadeIn,
  transitionStylesCrossFadeOut,
} from '../components/transitions';
import { BodyExtraLarge, BodyMedium, BodySmall } from '../components/typography';

export default function HomeExterior({ dispatch, state }) {
  const { currentScreen, prevScreen, selectedHome, SCREENS } = state;
  const bgVideo = selectedHome?.backgroundVideo;
  const metadata = `${selectedHome.beds} bd • ${selectedHome.baths} ba • ${selectedHome.sqFt} ft`;

  const nodeRef = useRef(null);
  const videoRef = useRef(null);

  return (
    <Transition
      in={currentScreen === SCREENS.HOME_EXTERIOR}
      mountOnEnter
      nodeRef={nodeRef}
      timeout={pageTransitionDurationMs}
      unmountOnExit
    >
      {transitionState => {
        const transitionStyles = (
          prevScreen === SCREENS.HOME_VIRTUAl_TOUR ||
          currentScreen === SCREENS.HOME_VIRTUAl_TOUR
        ) ? transitionStylesCrossFadeOut : transitionStylesCrossFadeIn;

        return (
          <Box
            ref={nodeRef}
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              transition: `all ${pageTransitionDurationMs}ms ease-in-out`,
              ...transitionStyles['exited'],
              ...transitionStyles[transitionState],
            }}
          >
            <video
              autoPlay
              loop
              muted
              preload=""
              ref={videoRef}
              id='home-exterior-page-video'
              style={{
                position: 'fixed',
                objectFit: 'cover',
                height: '100%',
                width: '100%',
                zIndex: -1
              }}
            >
              <source src={bgVideo?.url} type={bgVideo?.type} />
            </video>

            <Header dispatch={dispatch} state={state} />

            <Stack
              direction='column'
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                pb: 4.5,
                pl: 4,
              }}
            >
              <BodySmall sx={{ fontWeight: 500, mb: 0.25, textTransform: 'uppercase' }}>
                  {selectedHome.street}
              </BodySmall>
              <BodySmall sx={{ fontWeight: 500,  mb: 2 }}>
                {metadata}
              </BodySmall>
              <BodyExtraLarge>
                {(selectedHome.availability === 'SOLD') ? 'SOLD' : selectedHome.price}
              </BodyExtraLarge>
              <BodyMedium
                sx={{
                  fontFamily: 'Reckless',
                  mb: 3
                }}
              >
                {selectedHome.payment}
              </BodyMedium>
              <PrimaryButton
                label='Reserve Now'
                onClick={() => dispatch({ type: 'reserve-now-button-clicked' })}
                size='large'
              />
            </Stack>

            <Stack
              direction='row'
              spacing={1.5}
              sx={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                pb: 4.5,
                pr: 2,
              }}
            >
              <VideoControls videoRef={videoRef} />

              <NavButtonGroup
                dispatch={dispatch}
                state={state}
              />
            </Stack>
          </Box>
        );
      }}
    </Transition>
  );
}
